export const SERVICE = {
  BUBBLECHAT: 'bubblechat',
  TINGLE: 'tingle',
};
